import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Grid } from "@material-ui/core";
import "./dialog-delete-collaborator.css";

/* === Custom component title for dialog === */
const CustomDeleteSignatureTitleBar = (props) => {
  const { t } = useTranslation();
  return (
    <div className="dialogDeleteCollaborator-title">
      <span>{t("dialogDeleteCollaborator.titleDeleteCollaborator")}</span>
    </div>
  );
};

const DialogDeleteCollaboratorPure = (props) => {
  const { t } = useTranslation();

  return (
    <Dialog title={<CustomDeleteSignatureTitleBar />} onClose={props.remove}>
      {/* <form> */}
      <div className="k-form">
        <div style={{ marginBottom: "14px" }}>
          <Grid container xs={12} lg={12} md={12} sm={12} es={12}>
            {/* Label y TextArea */}
            <Grid item xs={12} lg={12} md={12} sm={12} es={12}>
              <p className="dialogDeleteCollaborator-label">
                ¿{t("dialogDeleteCollaborator.AreYouShureToDelete")}{" "}
                <span style={{ fontWeight: 600 }}>
                  {props.userInRemove.email}
                </span>
                ?
              </p>
            </Grid>
          </Grid>
        </div>
        <div
          item="true"
          xs={12}
          lg={12}
          md={12}
          sm={12}
          es={12}
          className="dialogDeleteCollaborators-btns-container"
        >
          <button
            className="dialogDeleteCollaborators-cancel"
            onClick={props.remove}
          >
            {t("button.cancel")}
          </button>
          <button
            className="dialogDeleteCollaborators-accept"
            type="submit"
            onClick={props.deleteCollaborator}
            disabled={props.disableUserButton}
          >
            {t("button.accept")}
          </button>
        </div>
      </div>
      {/* </form> */}
    </Dialog>
  );
};

export { DialogDeleteCollaboratorPure as default };
